const Be = 8;
function O(t) {
  return typeof t?.extends == "string" && t.extends.length > 0;
}
function v(t, e) {
  if (!O(t))
    return { model: t, errors: [] };
  const s = [t], i = /* @__PURE__ */ new Set([t.type]);
  let r = t;
  for (; O(r); ) {
    const c = r.extends;
    if (i.has(c))
      return {
        model: null,
        errors: [{
          code: "INHERITANCE_CYCLE",
          field: t.type,
          message: `Type '${t.type}' has a cyclic extends chain through '${c}'`
        }]
      };
    const l = e(c);
    if (!l)
      return {
        model: null,
        errors: [{
          code: "INHERITANCE_UNKNOWN_BASE",
          field: t.type,
          message: `Type '${r.type}' extends unknown type '${c}'`
        }]
      };
    if (i.add(c), s.push(l), s.length > 8)
      return {
        model: null,
        errors: [{
          code: "INHERITANCE_DEPTH_EXCEEDED",
          field: t.type,
          message: `Extends chain for '${t.type}' exceeds 8 levels`
        }]
      };
    r = l;
  }
  const o = r;
  if (!Array.isArray(o.fields))
    return {
      model: null,
      errors: [{
        code: "INHERITANCE_ROOT_INCOMPLETE",
        field: o.type,
        message: `Base type '${o.type}' has no fields to inherit`
      }]
    };
  const n = [];
  let a = o;
  for (let c = s.length - 2; c >= 0; c -= 1)
    a = Z(a, s[c], n);
  return n.length > 0 ? { model: null, errors: n } : { model: a, errors: [] };
}
function Z(t, e, s) {
  const i = ee(t.fields, e.fields ?? [], e.type, s), r = t.roles || e.roles ? { ...t.roles ?? {}, ...e.roles ?? {} } : void 0, o = {
    ...t,
    ...X(e),
    type: e.type,
    extends: e.extends,
    fields: i
  };
  return r && (o.roles = r), o;
}
function X(t) {
  const e = {};
  for (const [s, i] of Object.entries(t))
    i !== void 0 && (e[s] = i);
  return e;
}
function ee(t, e, s, i) {
  const r = /* @__PURE__ */ new Map();
  for (const n of e) r.set(n.name, n);
  const o = t.map((n) => {
    const a = r.get(n.name);
    return a ? (r.delete(n.name), te(n, a, s, i)) : n;
  });
  for (const n of e)
    r.has(n.name) && o.push(n);
  return o;
}
function te(t, e, s, i) {
  if (e.type !== void 0 && e.type !== t.type)
    return i.push({
      code: "INHERITANCE_FIELD_RETYPED",
      field: t.name,
      message: `Type '${s}' cannot retype inherited field '${t.name}' from '${t.type}' to '${e.type}'`
    }), t;
  if (t.options && e.options) {
    const o = new Set(t.options.map((a) => a.value)), n = e.options.filter((a) => !o.has(a.value));
    if (n.length > 0)
      return i.push({
        code: "INHERITANCE_OPTION_WIDENED",
        field: t.name,
        message: `Type '${s}' adds options to inherited select '${t.name}': ${n.map((a) => a.value).join(", ")}. A derived type may only narrow a base select.`
      }), t;
  }
  const r = { ...t, ...se(e), type: t.type };
  if (t.options && e.options) {
    const o = new Map(t.options.map((n) => [n.value, n]));
    r.options = e.options.map((n) => ({ ...o.get(n.value) ?? {}, ...n }));
  }
  return r;
}
function se(t) {
  const e = {};
  for (const [s, i] of Object.entries(t))
    i !== void 0 && (e[s] = i);
  return e;
}
const ie = /* @__PURE__ */ new Set(["type", "extends", "fields", "roles", "activity", "declaredForm"]);
function Ke(t, e) {
  const s = { type: t.type, extends: t.extends ?? e.type }, i = s;
  for (const [a, c] of Object.entries(t))
    ie.has(a) || c === void 0 || I(c) !== I(e[a]) && (i[a] = c);
  const r = new Map(e.fields.map((a) => [a.name, a])), o = t.fields.filter((a) => {
    const c = r.get(a.name);
    return !c || I(S(a)) !== I(S(c));
  });
  o.length > 0 && (s.fields = o);
  const n = {};
  for (const [a, c] of Object.entries(t.roles ?? {}))
    e.roles?.[a] !== c && (n[a] = c);
  return Object.keys(n).length > 0 && (s.roles = n), s;
}
function S(t) {
  return { ...t, required: t.required === !0, displayInline: t.displayInline !== !1 };
}
function I(t) {
  return JSON.stringify(t, (e, s) => s && typeof s == "object" && !Array.isArray(s) ? Object.fromEntries(Object.keys(s).sort().filter((i) => s[i] !== void 0).map((i) => [i, s[i]])) : s);
}
const C = [
  "repo-lines",
  "html-fragment",
  "pdf-page",
  "media-time",
  "result-path",
  "scope-node"
], F = 1, re = /^(?:me:|(?:team|org|public):[A-Za-z0-9._-]+)$/, ne = /^(?:me:|(?:team|org):[A-Za-z0-9._-]+)$/, oe = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/, ae = /^[a-z0-9]+-[A-Za-z0-9+/=_-]+$/, ce = /^[A-Za-z0-9][A-Za-z0-9._-]*$/, le = ["selectorType", "version"], x = {
  "repo-lines": ["repository", "commit", "path", "startLine", "endLine"],
  "html-fragment": ["fragment", "quote", "prefix", "suffix"],
  "pdf-page": ["page", "quote"],
  "media-time": ["start", "end"],
  "result-path": ["artifactDigest", "path"],
  "scope-node": ["scopeId", "nodeId", "revisionId", "serverRevision"]
};
function u(t, e, s) {
  return { code: t, path: e, message: s };
}
function ue(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function h(t, e, s, i) {
  const r = t[e];
  if (r == null) {
    s.push(u("LOCATOR_MISSING_FIELD", e, `'${e}' is required`));
    return;
  }
  if (typeof r != "string" || r.trim().length === 0) {
    s.push(u("LOCATOR_INVALID_FIELD", e, `'${e}' must be a non-empty string`));
    return;
  }
  i && !i.re.test(r) && s.push(u("LOCATOR_INVALID_FIELD", e, `'${e}' ${i.expectation}`));
}
function k(t, e, s) {
  const i = t[e];
  i !== void 0 && typeof i != "string" && s.push(u("LOCATOR_INVALID_FIELD", e, `'${e}' must be a string when present`));
}
function L(t, e, s, i) {
  const r = t[e];
  return r == null ? (i.push(u("LOCATOR_MISSING_FIELD", e, `'${e}' is required`)), null) : typeof r != "number" || !Number.isInteger(r) || r < s ? (i.push(
    u("LOCATOR_INVALID_FIELD", e, `'${e}' must be an integer >= ${s}`)
  ), null) : r;
}
function q(t, e, s, i) {
  const r = t[e];
  return r == null ? (i.push(u("LOCATOR_MISSING_FIELD", e, `'${e}' is required`)), null) : typeof r != "number" || !Number.isFinite(r) || r < s ? (i.push(u("LOCATOR_INVALID_FIELD", e, `'${e}' must be a finite number >= ${s}`)), null) : r;
}
function fe(t, e) {
  const s = e.length;
  if (h(t, "path", e), e.length !== s) return;
  const i = t.path;
  (i.startsWith("/") || i.split("/").includes("..")) && e.push(
    u(
      "LOCATOR_INVALID_FIELD",
      "path",
      "'path' must be repository-relative, with no leading slash and no '..' segment"
    )
  );
}
function pe(t, e, s) {
  switch (t) {
    case "repo-lines": {
      h(e, "repository", s), h(e, "commit", s, {
        re: ce,
        expectation: "must be a resolved commit id, not a path or URL"
      }), fe(e, s);
      const i = L(e, "startLine", 1, s), r = L(e, "endLine", 1, s);
      i !== null && r !== null && r < i && s.push(
        u("LOCATOR_RANGE_INVERTED", "endLine", `'endLine' (${r}) is before 'startLine' (${i})`)
      );
      return;
    }
    case "html-fragment": {
      for (const o of x["html-fragment"]) k(e, o, s);
      const i = typeof e.fragment == "string" && e.fragment.trim().length > 0, r = typeof e.quote == "string" && e.quote.trim().length > 0;
      !i && !r && s.push(
        u(
          "LOCATOR_MISSING_FIELD",
          "",
          "'html-fragment' requires at least one of 'fragment' or 'quote'"
        )
      );
      return;
    }
    case "pdf-page": {
      L(e, "page", 1, s), k(e, "quote", s);
      return;
    }
    case "media-time": {
      const i = q(e, "start", 0, s);
      if (e.end === void 0) return;
      const r = q(e, "end", 0, s);
      i !== null && r !== null && r < i && s.push(
        u("LOCATOR_RANGE_INVERTED", "end", `'end' (${r}) is before 'start' (${i})`)
      );
      return;
    }
    case "result-path": {
      h(e, "artifactDigest", s, {
        re: ae,
        expectation: "must look like '<algorithm>-<value>', e.g. 'sha256-...'"
      });
      const i = s.length;
      h(e, "path", s), s.length === i && !e.path.startsWith("$") && s.push(
        u("LOCATOR_INVALID_FIELD", "path", "'path' must be a JSONPath beginning with '$'")
      );
      return;
    }
    case "scope-node": {
      const i = s.length;
      h(e, "scopeId", s, {
        re,
        expectation: "must be 'me:', 'team:<id>', or 'org:<id>'"
      }), s.length === i && !ne.test(e.scopeId) && s.push(
        u(
          "LOCATOR_SCOPE_NODE_UNVERSIONED_SCOPE",
          "scopeId",
          `'scope-node' addresses a record by revision UUID, which scope '${e.scopeId}' does not assign; reference it as an external reference instead`
        )
      ), h(e, "nodeId", s), h(e, "revisionId", s, {
        re: oe,
        expectation: "must be a revision UUID, not a room-assigned revision number"
      }), e.serverRevision !== void 0 && L(e, "serverRevision", 1, s);
      return;
    }
  }
}
function Q(t) {
  if (!ue(t))
    return {
      valid: !1,
      locator: null,
      issues: [u("LOCATOR_NOT_AN_OBJECT", "", "A locator must be an object")]
    };
  const e = [], s = t.selectorType;
  if (s == null || s === "")
    return e.push(u("LOCATOR_MISSING_SELECTOR_TYPE", "selectorType", "'selectorType' is required")), { valid: !1, locator: null, issues: e };
  if (typeof s != "string" || !C.includes(s))
    return e.push(
      u(
        "LOCATOR_UNKNOWN_SELECTOR_TYPE",
        "selectorType",
        `Unknown selectorType '${String(s)}'; expected one of ${C.join(", ")}`
      )
    ), { valid: !1, locator: null, issues: e };
  const i = s;
  t.version === void 0 || t.version === null ? e.push(u("LOCATOR_MISSING_VERSION", "version", "'version' is required")) : t.version !== F && e.push(
    u(
      "LOCATOR_UNSUPPORTED_VERSION",
      "version",
      `Unsupported locator version ${String(t.version)}; this build understands ${F}`
    )
  );
  const r = /* @__PURE__ */ new Set([...le, ...x[i]]);
  for (const o of Object.keys(t))
    r.has(o) || e.push(
      u(
        "LOCATOR_UNKNOWN_FIELD",
        o,
        `'${o}' is not part of a '${i}' locator`
      )
    );
  return pe(i, t, e), e.length > 0 ? { valid: !1, locator: null, issues: e } : { valid: !0, locator: t, issues: [] };
}
function de(t) {
  if (!Array.isArray(t))
    return {
      valid: !1,
      locators: null,
      issues: [u("LOCATOR_NOT_AN_ARRAY", "", "A multi-valued locator field must be an array")]
    };
  const e = [], s = [];
  return t.forEach((i, r) => {
    const o = Q(i);
    if (o.valid) {
      s.push(o.locator);
      return;
    }
    for (const n of o.issues)
      e.push({
        ...n,
        path: n.path ? `[${r}].${n.path}` : `[${r}]`
      });
  }), e.length > 0 ? { valid: !1, locators: null, issues: e } : { valid: !0, locators: s, issues: [] };
}
function Ye(t) {
  switch (t.selectorType) {
    case "repo-lines":
      return `${t.path}:${t.startLine}` + (t.endLine > t.startLine ? `-${t.endLine}` : "") + ` @ ${t.commit.slice(0, 8)}`;
    case "html-fragment":
      return t.fragment ? `#${t.fragment.replace(/^#/, "")}` : `"${t.quote ?? ""}"`;
    case "pdf-page":
      return `p. ${t.page}`;
    case "media-time":
      return t.end === void 0 ? R(t.start) : `${R(t.start)}-${R(t.end)}`;
    case "result-path":
      return `${t.path} @ ${t.artifactDigest.slice(0, 15)}`;
    case "scope-node":
      return `${t.scopeId.endsWith(":") ? t.scopeId : `${t.scopeId}:`}${t.nodeId}` + (t.serverRevision === void 0 ? "" : ` rev ${t.serverRevision}`);
  }
}
function R(t) {
  const e = Math.floor(t), s = Math.floor(e / 60), i = e % 60;
  return `${s}:${String(i).padStart(2, "0")}`;
}
const he = [
  "entity",
  "text",
  "boolean-assessment",
  "quantity",
  "select"
], me = ["directed", "symmetric"];
function p(t, e, s) {
  return { code: t, path: e, message: s };
}
function ge(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
const ye = /^[a-z0-9][a-z0-9-]*$/, Ee = [
  "id",
  "label",
  "inverseLabel",
  "subjectKinds",
  "objectKinds",
  "valueShape",
  "direction",
  "transitive"
];
function b(t, e) {
  return e.length > 0 ? { ...t, warnings: e } : t;
}
function Ie(t) {
  if (!ge(t))
    return {
      valid: !1,
      predicate: null,
      issues: [p("PREDICATE_NOT_AN_OBJECT", "", "A predicate declaration must be an object")]
    };
  const e = [], s = [];
  for (const i of Object.keys(t))
    Ee.includes(i) || s.push(p("PREDICATE_UNKNOWN_FIELD", i, `'${i}' is not part of a predicate declaration`));
  return w(t, "id", e, {
    re: ye,
    expectation: "must be lowercase letters, digits, and hyphens"
  }), w(t, "label", e), Ae(t, "inverseLabel", e), t.subjectKinds === void 0 ? e.push(p("PREDICATE_MISSING_FIELD", "subjectKinds", "'subjectKinds' is required")) : (!Array.isArray(t.subjectKinds) || t.subjectKinds.length === 0 || t.subjectKinds.some((i) => typeof i != "string" || i.trim().length === 0)) && e.push(
    p(
      "PREDICATE_INVALID_FIELD",
      "subjectKinds",
      "'subjectKinds' must be a non-empty array of tracker type names, or ['*']"
    )
  ), t.objectKinds !== void 0 && (!Array.isArray(t.objectKinds) || t.objectKinds.length === 0 || t.objectKinds.some((i) => typeof i != "string" || i.trim().length === 0)) && e.push(
    p(
      "PREDICATE_INVALID_FIELD",
      "objectKinds",
      "'objectKinds' must be a non-empty array of tracker type names, or ['*'], when present"
    )
  ), j(t, "valueShape", he, e), j(t, "direction", me, e), t.transitive !== void 0 && typeof t.transitive != "boolean" && e.push(p("PREDICATE_INVALID_FIELD", "transitive", "'transitive' must be a boolean when present")), e.length > 0 ? b({ valid: !1, predicate: null, issues: e }, s) : b(
    { valid: !0, predicate: t, issues: [] },
    s
  );
}
function xe(t) {
  if (!Array.isArray(t))
    return {
      valid: !1,
      predicates: null,
      issues: [p("PREDICATE_REGISTRY_NOT_AN_ARRAY", "", "A predicate registry must be an array of declarations")]
    };
  const e = [], s = [], i = [], r = /* @__PURE__ */ new Set();
  return t.forEach((o, n) => {
    const a = Ie(o);
    for (const c of a.warnings ?? [])
      s.push({
        ...c,
        path: c.path ? `[${n}].${c.path}` : `[${n}]`
      });
    if (!a.valid) {
      for (const c of a.issues)
        e.push({
          ...c,
          path: c.path ? `[${n}].${c.path}` : `[${n}]`
        });
      return;
    }
    if (r.has(a.predicate.id)) {
      e.push(
        p("PREDICATE_DUPLICATE_ID", `[${n}].id`, `Predicate '${a.predicate.id}' is declared more than once`)
      );
      return;
    }
    r.add(a.predicate.id), i.push(a.predicate);
  }), e.length > 0 ? b({ valid: !1, predicates: null, issues: e }, s) : b({ valid: !0, predicates: i, issues: [] }, s);
}
function H(t, e, s) {
  if (t.includes("*")) return !0;
  let i = e;
  for (let r = 0; i && r < 16; r += 1) {
    if (t.includes(i)) return !0;
    i = s?.(i);
  }
  return !1;
}
function G(t, e) {
  switch (t) {
    case "entity":
      return e === "relationship" || e === "reference";
    case "text":
      return e === "string" || e === "text";
    case "quantity":
      return e === "number";
    case "boolean-assessment":
      return e === "select";
    case "select":
      return e === "select" || e === "multiselect";
  }
}
function Le(t, e, s) {
  if (!e)
    return [
      p(
        "PREDICATE_UNKNOWN",
        "predicate",
        `No predicate '${t}' is declared in this project's registry`
      )
    ];
  const i = [];
  return G(e.valueShape, s.fieldType) || i.push(
    p(
      "PREDICATE_VALUE_SHAPE_MISMATCH",
      "predicate",
      `Predicate '${e.id}' has value shape '${e.valueShape}', which a '${s.fieldType}' field cannot carry`
    )
  ), H(e.subjectKinds, s.ownerType, s.baseOf) || i.push(
    p(
      "PREDICATE_SUBJECT_KIND_NOT_ALLOWED",
      "predicate",
      `Predicate '${e.id}' accepts subjects of ${e.subjectKinds.join(", ")}, not '${s.ownerType}'`
    )
  ), i;
}
function Qe(t, e, s) {
  const i = [];
  for (const r of t.fields) {
    if (!r.predicate) continue;
    const o = Le(r.predicate, e(r.predicate), {
      ownerType: t.type,
      fieldType: r.type,
      baseOf: s
    });
    for (const n of o)
      i.push({ ...n, path: `fields.${r.name}.${n.path}` });
  }
  return i;
}
function w(t, e, s, i) {
  const r = t[e];
  if (r == null) {
    s.push(p("PREDICATE_MISSING_FIELD", e, `'${e}' is required`));
    return;
  }
  if (typeof r != "string" || r.trim().length === 0) {
    s.push(p("PREDICATE_INVALID_FIELD", e, `'${e}' must be a non-empty string`));
    return;
  }
  i && !i.re.test(r) && s.push(p("PREDICATE_INVALID_FIELD", e, `'${e}' ${i.expectation}`));
}
function Ae(t, e, s) {
  const i = t[e];
  i !== void 0 && typeof i != "string" && s.push(p("PREDICATE_INVALID_FIELD", e, `'${e}' must be a string when present`));
}
function j(t, e, s, i) {
  const r = t[e];
  if (r == null) {
    i.push(p("PREDICATE_MISSING_FIELD", e, `'${e}' is required`));
    return;
  }
  (typeof r != "string" || !s.includes(r)) && i.push(
    p(
      "PREDICATE_INVALID_FIELD",
      e,
      `'${e}' must be one of ${s.join(", ")}`
    )
  );
}
const M = [
  "string",
  "number",
  "boolean",
  "date",
  "select",
  "relationship",
  "array"
], U = [
  "string",
  "number",
  "boolean"
];
function f(t, e, s) {
  return { code: t, path: e, message: s };
}
function _(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
const be = /^[A-Za-z][A-Za-z0-9_-]*$/, _e = [
  "type",
  "required",
  "itemType",
  "options",
  "targetTrackerTypes",
  "label",
  "description"
];
function He(t, e, s, i = s) {
  const r = `qualifiers.${t}`;
  if (be.test(t) || s.push(
    f("LABEL_INVALID_FIELD", r, `Qualifier name '${t}' must start with a letter and contain no spaces or dots`)
  ), !_(e)) {
    s.push(f("LABEL_INVALID_FIELD", r, `Qualifier '${t}' must be an object`));
    return;
  }
  for (const n of Object.keys(e))
    _e.includes(n) || i.push(f("LABEL_UNKNOWN_FIELD", `${r}.${n}`, `'${n}' is not part of a qualifier declaration`));
  const o = e.type;
  if (o === void 0 ? s.push(f("LABEL_MISSING_FIELD", `${r}.type`, `Qualifier '${t}' is missing 'type'`)) : (typeof o != "string" || !M.includes(o)) && s.push(
    f(
      "LABEL_INVALID_FIELD",
      `${r}.type`,
      `Qualifier '${t}' has unknown type '${String(o)}'; expected one of ${M.join(", ")}`
    )
  ), e.required !== void 0 && typeof e.required != "boolean" && s.push(f("LABEL_INVALID_FIELD", `${r}.required`, "'required' must be a boolean when present")), e.itemType !== void 0 && (typeof e.itemType != "string" || !U.includes(e.itemType) ? s.push(
    f(
      "LABEL_INVALID_FIELD",
      `${r}.itemType`,
      `'itemType' must be one of ${U.join(", ")}`
    )
  ) : o !== "array" && s.push(f("LABEL_INVALID_FIELD", `${r}.itemType`, "'itemType' only applies to an 'array' qualifier"))), e.options !== void 0 ? !Array.isArray(e.options) || e.options.length === 0 || e.options.some((n) => typeof n != "string" || n.length === 0) ? s.push(f("LABEL_INVALID_FIELD", `${r}.options`, "'options' must be a non-empty array of strings")) : o !== "select" && s.push(f("LABEL_INVALID_FIELD", `${r}.options`, "'options' only applies to a 'select' qualifier")) : o === "select" && s.push(f("LABEL_MISSING_FIELD", `${r}.options`, "A 'select' qualifier must declare 'options'")), e.targetTrackerTypes !== void 0) {
    const n = e.targetTrackerTypes;
    n === "*" || Array.isArray(n) && n.length > 0 && n.every((c) => typeof c == "string" && c.length > 0) ? o !== "relationship" && s.push(
      f(
        "LABEL_INVALID_FIELD",
        `${r}.targetTrackerTypes`,
        "'targetTrackerTypes' only applies to a 'relationship' qualifier"
      )
    ) : s.push(
      f(
        "LABEL_INVALID_FIELD",
        `${r}.targetTrackerTypes`,
        "'targetTrackerTypes' must be '*' or a non-empty array of tracker type names"
      )
    );
  }
  for (const n of ["label", "description"])
    e[n] !== void 0 && typeof e[n] != "string" && s.push(f("LABEL_INVALID_FIELD", `${r}.${n}`, `'${n}' must be a string when present`));
}
function Te(t, e, s) {
  if (s != null && !_(s))
    return [f("LABEL_QUALIFIERS_NOT_AN_OBJECT", "", `Qualifiers for '${t}' must be an object`)];
  const i = e ?? {}, r = _(s) ? s : {}, o = [];
  for (const [n, a] of Object.entries(i)) {
    const c = r[n];
    if (c == null || c === "") {
      a.required && o.push(f("LABEL_QUALIFIER_REQUIRED", n, `Property '${t}' requires qualifier '${n}'`));
      continue;
    }
    $e(t, n, a, c, o);
  }
  for (const n of Object.keys(r))
    n in i || o.push(f("LABEL_QUALIFIER_UNKNOWN", n, `Property '${t}' declares no qualifier '${n}'`));
  return o;
}
function $e(t, e, s, i, r) {
  const o = (n) => r.push(
    f("LABEL_QUALIFIER_INVALID_TYPE", e, `Qualifier '${e}' of '${t}' must be ${n}`)
  );
  switch (s.type) {
    case "string":
      typeof i != "string" && o("a string");
      return;
    case "number":
      (typeof i != "number" || !Number.isFinite(i)) && o("a finite number");
      return;
    case "boolean":
      typeof i != "boolean" && o("a boolean");
      return;
    case "date":
      (typeof i != "string" || Number.isNaN(Date.parse(i))) && o("an ISO date string");
      return;
    case "select":
      if (typeof i != "string") {
        o("a string");
        return;
      }
      s.options && !s.options.includes(i) && r.push(
        f(
          "LABEL_QUALIFIER_INVALID_OPTION",
          e,
          `Qualifier '${e}' of '${t}' must be one of ${s.options.join(", ")}`
        )
      );
      return;
    case "relationship": {
      const n = Array.isArray(i) ? i : [i];
      if (n.length === 0) {
        o("a relationship reference with an itemId");
        return;
      }
      for (const a of n) {
        const c = _(a) ? a.itemId : void 0;
        if (typeof c != "string" || c.length === 0) {
          o("a relationship reference with an itemId");
          return;
        }
      }
      return;
    }
    case "array": {
      if (!Array.isArray(i)) {
        o("an array");
        return;
      }
      const n = s.itemType;
      n && !i.every((a) => typeof a === n) && o(`an array of ${n}`);
      return;
    }
  }
}
const Ne = {
  "qualifier-added": !1,
  "qualifier-made-optional": !1,
  "qualifier-option-added": !1,
  "qualifier-removed": !0,
  "qualifier-made-required": !0,
  "qualifier-type-changed": !0,
  "qualifier-option-removed": !0,
  "qualifier-definition-changed": !0
};
function T(t) {
  return Array.isArray(t) ? `[${t.map(T).join(",")}]` : t && typeof t == "object" ? `{${Object.entries(t).sort(([s], [i]) => s.localeCompare(i)).map(([s, i]) => `${JSON.stringify(s)}:${T(i)}`).join(",")}}` : JSON.stringify(t);
}
function V(t) {
  const {
    type: e,
    required: s,
    options: i,
    label: r,
    description: o,
    ...n
  } = t;
  return n;
}
function Ge(t, e) {
  const s = [], i = (n, a) => s.push({ kind: n, qualifierName: a, destructive: Ne[n] }), r = t ?? {}, o = e ?? {};
  for (const n of Object.keys(r))
    n in o || i("qualifier-removed", n);
  for (const [n, a] of Object.entries(o)) {
    const c = r[n];
    if (!c) {
      i(a.required ? "qualifier-made-required" : "qualifier-added", n);
      continue;
    }
    c.type !== a.type && i("qualifier-type-changed", n);
    const l = c.required === !0, d = a.required === !0;
    !l && d ? i("qualifier-made-required", n) : l && !d && i("qualifier-made-optional", n);
    const m = c.options ?? [], E = a.options ?? [];
    for (const N of m) E.includes(N) || i("qualifier-option-removed", n);
    for (const N of E) m.includes(N) || i("qualifier-option-added", n);
    T(V(c)) !== T(V(a)) && i("qualifier-definition-changed", n);
  }
  return s;
}
const ze = ["page", "structure", "market-node"], Je = [
  "string",
  "text",
  "number",
  "date",
  "datetime",
  "select",
  "multiselect",
  "boolean",
  "url",
  "user",
  "relationship",
  "array"
];
function P() {
  return { labels: [], properties: [], claimProperties: {} };
}
function Re(t) {
  return t.labels.length === 0 && t.properties.length === 0 && Object.keys(t.claimProperties).length === 0;
}
const De = [
  "title",
  "kind",
  "labels",
  "status",
  "parent",
  "aliases",
  "scopeId",
  "reviewState",
  "summary",
  "website",
  "tags",
  "created",
  "updated"
];
function A(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function y(t, e, s) {
  return { code: t, path: e, message: s };
}
function W(t, e) {
  const s = t[e];
  return s ?? (A(t.customFields) ? t.customFields[e] : void 0);
}
function Oe(t) {
  const e = [], s = (r) => {
    typeof r == "string" && r.length > 0 && !e.includes(r) && e.push(r);
  }, i = W(t, "labels");
  return Array.isArray(i) ? i.forEach(s) : s(i), s(W(t, "kind")), e;
}
function g(t) {
  return new Map(t.labels.map((e) => [e.id, e]));
}
function $(t, e) {
  const s = [...t], i = new Set(s);
  for (let r = 0; r < s.length; r += 1)
    for (const o of e.get(s[r])?.broader ?? [])
      i.has(o) || (i.add(o), s.push(o));
  return s;
}
function z(t, e) {
  return $(Oe(e), g(t));
}
function Ze(t, e) {
  return $([e], g(t)).slice(1);
}
function Pe(t, e) {
  const s = g(t);
  return t.labels.filter((i) => i.id !== e && $([i.id], s).includes(e)).map((i) => i.id);
}
function J(t, e, s) {
  const i = g(t), r = new Map(t.properties.map((c) => [c.id, c])), o = s.baseFieldNames ?? De, n = /* @__PURE__ */ new Set(), a = [];
  for (const c of e)
    for (const l of i.get(c)?.properties ?? []) {
      if (n.has(l)) continue;
      n.add(l);
      const d = r.get(l), m = t.claimProperties[l], E = d ? "field" : m || s.isPredicate?.(l) ? "claim" : o.includes(l) ? "base-field" : "unknown";
      a.push({
        id: l,
        storage: E,
        viaLabel: c,
        ...d ? { definition: d } : {},
        ...m ? { claim: m } : {}
      });
    }
  return a;
}
function ve(t, e, s = {}) {
  return J(t, z(t, e), s);
}
function Se(t, e, s = {}) {
  return J(t, $([e], g(t)), s);
}
function Ce(t) {
  return (t.options ?? []).map((e) => typeof e == "string" ? e : e.value);
}
function Fe(t) {
  return !!t.qualifiers && Object.keys(t.qualifiers).length > 0;
}
function ke(t, e) {
  const s = [];
  let i = e;
  if (Fe(t))
    if (A(e) && "value" in e) {
      i = e.value;
      for (const a of Te(t.id, t.qualifiers, e.qualifiers))
        s.push({ ...a, path: `qualifiers${a.path ? `.${a.path}` : ""}` });
    } else
      s.push(y(
        "LABEL_PROPERTY_EXPECTS_QUALIFIED_VALUE",
        "",
        `Property '${t.id}' declares qualifiers, so its value is stored as { value, qualifiers }`
      ));
  if (i == null) return s;
  const r = (a) => s.push(y("LABEL_PROPERTY_INVALID_VALUE", "", `Property '${t.id}' must be ${a}`)), o = Ce(t), n = (a) => {
    typeof a != "string" ? r("a string option") : o.length > 0 && !o.includes(a) && s.push(y("LABEL_PROPERTY_UNKNOWN_OPTION", "", `Property '${t.id}' has an unrecognized option: ${a}`));
  };
  switch (t.type) {
    case "string":
    case "text":
    case "user":
      typeof i != "string" && r("a string");
      break;
    case "number":
      (typeof i != "number" || !Number.isFinite(i)) && r("a finite number");
      break;
    case "boolean":
      typeof i != "boolean" && r("a boolean");
      break;
    case "date":
    case "datetime":
      (typeof i != "string" || Number.isNaN(Date.parse(i))) && r("an ISO date string");
      break;
    case "select":
      n(i);
      break;
    case "multiselect":
      Array.isArray(i) ? i.forEach(n) : r("an array of options");
      break;
    case "url": {
      const a = typeof i == "string" ? i : A(i) ? i.url : void 0;
      (typeof a != "string" || a.length === 0) && r("a URL string or { url, label }");
      break;
    }
    case "relationship": {
      (Array.isArray(i) ? i : [i]).every((c) => A(c) && typeof c.itemId == "string" && c.itemId.length > 0) || r("a relationship reference with an itemId");
      break;
    }
    case "array":
      Array.isArray(i) || r("an array");
      break;
  }
  return s;
}
function qe(t, e) {
  const s = Array.isArray(e) ? e : [e];
  if (!s.every((o) => typeof o == "string" && o.length > 0))
    return { errors: [y("LABEL_REF_INVALID", "", "Labels must be label ids")], warnings: [] };
  if (t.labels.length === 0) return { errors: [], warnings: [] };
  const i = g(t), r = s.filter((o) => !i.has(o)).map((o) => y("LABEL_UNKNOWN", "", `Unknown label '${o}'`));
  return { errors: [], warnings: r };
}
class we {
  constructor() {
    this.models = /* @__PURE__ */ new Map(), this.builtinTypes = /* @__PURE__ */ new Set(), this.builtinModels = /* @__PURE__ */ new Map(), this.listeners = /* @__PURE__ */ new Set(), this.workspaceLayers = /* @__PURE__ */ new Map(), this.activeWorkspace = null, this.scopeProvider = null, this.declarations = /* @__PURE__ */ new Map(), this.predicates = /* @__PURE__ */ new Map(), this.workspacePredicateLayers = /* @__PURE__ */ new Map(), this.labelRegistry = P(), this.workspaceLabelLayers = /* @__PURE__ */ new Map(), this.isPredicate = (e) => this.scopedPredicates().has(e), this.baseOf = (e) => this.get(e)?.extends;
  }
  register(e, s = !1) {
    if (O(e)) {
      this.registerDerived(e, s);
      return;
    }
    const i = D(e);
    this.models.set(i.type, i), s && (this.builtinTypes.add(i.type), this.builtinModels.set(i.type, i)), this.resolveDeclarations(), this.listeners.forEach((r) => r());
  }
  /**
   * Store a derived declaration and resolve it. A declaration whose base is not
   * registered YET stays pending rather than throwing: types arrive in whatever
   * order the room published them. Any other resolution failure throws, so a
   * declaration that violates the narrowing rules cannot register a model that
   * silently drops base fields.
   */
  registerDerived(e, s) {
    const { errors: i } = v(e, (o) => this.declaredFor(o)), r = i.filter((o) => o.code !== "INHERITANCE_UNKNOWN_BASE");
    if (r.length > 0)
      throw new Error(`Cannot register tracker type '${e.type}': ${r.map((o) => o.message).join("; ")}`);
    this.declarations.set(e.type, { declared: e, builtin: s }), s && this.builtinTypes.add(e.type), this.resolveDeclarations(), this.listeners.forEach((o) => o());
  }
  /** The declaration a resolution should read for `type`: derived form first. */
  declaredFor(e) {
    return this.declarations.get(e)?.declared ?? this.models.get(e) ?? this.builtinModels.get(e);
  }
  /** Re-resolve every derived type against the current base set. */
  resolveDeclarations() {
    for (const [e, { declared: s, builtin: i }] of this.declarations) {
      const { model: r } = v(s, (n) => this.declaredFor(n));
      if (!r) {
        this.models.delete(e), i && this.builtinModels.delete(e);
        continue;
      }
      const o = D(r);
      this.models.set(e, o), i && this.builtinModels.set(e, o);
    }
  }
  /** The authored form of a derived type, or undefined for a plain type. */
  getDeclaredModel(e) {
    return this.declarations.get(e)?.declared;
  }
  /** Derived types whose base has not been registered, for diagnostics. */
  getUnresolvedDerivedTypes() {
    return Array.from(this.declarations.keys()).filter((e) => !this.models.has(e));
  }
  /** Remove a specific type from the registry. Cannot remove built-in types. */
  unregister(e) {
    if (this.builtinTypes.has(e)) return !1;
    const s = this.models.delete(e), i = this.declarations.delete(e);
    return (s || i) && this.listeners.forEach((r) => r()), s;
  }
  /**
   * Remove one workspace-provided schema. Built-in overrides restore the
   * original built-in model; custom workspace types are deleted.
   */
  clearWorkspaceSchema(e) {
    let s = !1;
    if (this.builtinTypes.has(e)) {
      const i = this.builtinModels.get(e);
      i && this.models.get(e) !== i && (this.models.set(e, i), s = !0);
    } else
      s = this.models.delete(e), this.declarations.delete(e) && (s = !0);
    return s && this.listeners.forEach((i) => i()), s;
  }
  /**
   * Remove all workspace-specific (non-builtin) schemas.
   * Call this on workspace switch to prevent schemas from workspace A
   * leaking into workspace B.
   *
   * `keepVocabulary` is for reloading the SAME workspace's schemas: the label
   * and predicate registries stay in force, so no listener ever observes them
   * empty, and the caller replaces them whole once the fresh copy arrives.
   */
  clearWorkspaceSchemas(e = {}) {
    let s = !1;
    e.keepVocabulary || (this.predicates.size > 0 && (this.predicates = /* @__PURE__ */ new Map(), s = !0), Re(this.labelRegistry) || (s = !0), this.labelRegistry = P());
    for (const i of Array.from(this.models.keys()))
      if (this.builtinTypes.has(i)) {
        const r = this.builtinModels.get(i);
        r && this.models.get(i) !== r && (this.models.set(i, r), s = !0);
      } else
        this.models.delete(i), this.declarations.delete(i), s = !0;
    s && this.listeners.forEach((i) => i());
  }
  /** Subscribe to registry changes. Returns an unsubscribe function. */
  onChange(e) {
    return this.listeners.add(e), () => {
      this.listeners.delete(e);
    };
  }
  // -------------------------------------------------------------------------
  // Workspace scoping (#1035)
  // -------------------------------------------------------------------------
  /**
   * Install the ambient scope resolver. The host calls this once; returning a
   * workspace path from `fn` makes reads on the current async context resolve
   * against that workspace's layer instead of the active view.
   */
  setScopeProvider(e) {
    this.scopeProvider = e;
  }
  /**
   * Declare which workspace the live `models` view represents. Any cached layer
   * for that workspace is dropped — the live view supersedes it (and the caller
   * reloads it from disk).
   */
  setActiveWorkspace(e) {
    this.activeWorkspace = e, e && (this.workspaceLayers.delete(e), this.workspacePredicateLayers.delete(e), this.workspaceLabelLayers.delete(e));
  }
  /** The workspace the live view currently represents, if declared. */
  getActiveWorkspace() {
    return this.activeWorkspace;
  }
  /**
   * Replace the cached schema layer for a NON-active workspace. Does not touch
   * the active view, so a read-only lookup for another project can never
   * clobber the open project's schemas. No change notification is emitted:
   * nothing the active workspace can observe has changed.
   */
  setWorkspaceLayer(e, s) {
    const i = /* @__PURE__ */ new Map();
    for (const r of s) {
      const o = D(r);
      i.set(o.type, o);
    }
    this.workspaceLayers.set(e, i);
  }
  /** Drop a cached non-active workspace layer. */
  clearWorkspaceLayer(e) {
    this.workspaceLayers.delete(e), this.workspacePredicateLayers.delete(e), this.workspaceLabelLayers.delete(e);
  }
  // -------------------------------------------------------------------------
  // Predicate registry (contract 4.1)
  // -------------------------------------------------------------------------
  /**
   * Replace the active view's predicate registry.
   *
   * Replace, not merge: the registry is published by the room as a whole
   * artifact, so a merge would silently keep a predicate the team deleted and
   * every client's view of "what verbs exist" would depend on what it happened
   * to have seen before.
   */
  setPredicates(e) {
    this.predicates = new Map(e.map((s) => [s.id, s])), this.listeners.forEach((s) => s());
  }
  /** Replace the cached registry for a NON-active workspace. No notification. */
  setWorkspacePredicateLayer(e, s) {
    this.workspacePredicateLayers.set(
      e,
      new Map(s.map((i) => [i.id, i]))
    );
  }
  /**
   * The registry a read should resolve against.
   *
   * Note the absence of a builtin fallback, which `get()` has for types: there
   * are no builtin predicates. A project with no published registry has no
   * predicates, and a field declaring one there reports `PREDICATE_UNKNOWN`,
   * which is the truthful answer.
   */
  scopedPredicates() {
    if (!this.activeWorkspace) return this.predicates;
    const e = this.scopeProvider?.();
    return !e || e === this.activeWorkspace ? this.predicates : this.workspacePredicateLayers.get(e) ?? Ue;
  }
  getPredicate(e) {
    return this.scopedPredicates().get(e);
  }
  getAllPredicates() {
    return Array.from(this.scopedPredicates().values());
  }
  /** Resolve for an EXPLICIT workspace, with no dependence on async context. */
  getPredicateForWorkspace(e, s) {
    return !e || !this.activeWorkspace || e === this.activeWorkspace ? this.predicates.get(s) : this.workspacePredicateLayers.get(e)?.get(s);
  }
  // -------------------------------------------------------------------------
  // Label registry (see labelRegistry.ts)
  // -------------------------------------------------------------------------
  /** Replace the active view's label registry. */
  setLabels(e) {
    this.labelRegistry = e, this.listeners.forEach((s) => s());
  }
  /** Replace the cached label registry for a NON-active workspace. No notification. */
  setWorkspaceLabelLayer(e, s) {
    this.workspaceLabelLayers.set(e, s);
  }
  /** The label registry a read should resolve against (scoped like predicates). */
  getLabelRegistry() {
    if (!this.activeWorkspace) return this.labelRegistry;
    const e = this.scopeProvider?.();
    return !e || e === this.activeWorkspace ? this.labelRegistry : this.workspaceLabelLayers.get(e) ?? K;
  }
  getLabelRegistryForWorkspace(e) {
    return !e || !this.activeWorkspace || e === this.activeWorkspace ? this.labelRegistry : this.workspaceLabelLayers.get(e) ?? K;
  }
  /**
   * Whether items of this type carry labels: the type declares a `label-ref`
   * field. Everything else (a bug whose free-form tags live in a `labels`
   * array, a type with its own `kind`) gets no label fields, no label value
   * checks, and no unknown-label warnings. Rendering and validation gate
   * {@link resolveLabels} and {@link effectiveProperties} on this.
   */
  acceptsLabels(e) {
    const s = this.get(e);
    return s ? B(s) : !1;
  }
  /** Item labels plus legacy `kind`, closed under `broader`. */
  resolveLabels(e) {
    return z(this.getLabelRegistry(), e);
  }
  /** Union of properties over the item's effective labels, own labels first. */
  effectiveProperties(e) {
    return ve(this.getLabelRegistry(), e, { isPredicate: this.isPredicate });
  }
  labelDescendants(e) {
    return Pe(this.getLabelRegistry(), e);
  }
  /** Instance-table columns: the label's properties, then its ancestors'. */
  tableColumns(e) {
    return Se(this.getLabelRegistry(), e, { isPredicate: this.isPredicate });
  }
  /**
   * The layer a read should resolve against, or null to use the active view.
   *
   * When no workspace has claimed the live view (`activeWorkspace === null`)
   * every read stays unscoped: the view is nobody's to corrupt, and scoping it
   * would hide types registered before any workspace window opened (NIM-760).
   */
  scopedLayer() {
    if (!this.activeWorkspace) return null;
    const e = this.scopeProvider?.();
    return !e || e === this.activeWorkspace ? null : this.workspaceLayers.get(e) ?? Me;
  }
  get(e) {
    const s = this.scopedLayer();
    return s ? s.get(e) ?? this.builtinModels.get(e) : this.models.get(e);
  }
  /** True when a cached layer exists for a non-active workspace. */
  hasWorkspaceLayer(e) {
    return this.workspaceLayers.has(e);
  }
  /**
   * Resolve a type on behalf of an EXPLICIT workspace, with no dependence on
   * ambient async context (#1359 / NIM-3702).
   *
   * `get()` reaches the right answer only when a scope provider is installed on
   * the current async context, which is true for exactly one consumer — the MCP
   * HTTP server, which wraps a whole request. The tracker sync lane is driven
   * from a WebSocket `onStatusChange` callback that has no such relationship to
   * whoever opened the workspace, so it lost the scope and read the *other*
   * project's schemas. Callers that already hold a workspace path use this.
   *
   * Note the builtin fallback: `get()`'s unscoped branch does not have one, so
   * a miss there returned `undefined` even for `bug`/`task`/`plan`/`decision`,
   * all of which ship `sharing: team`. Both branches fall back here.
   */
  getForWorkspace(e, s) {
    return !e || !this.activeWorkspace || e === this.activeWorkspace ? this.models.get(s) ?? this.builtinModels.get(s) : this.workspaceLayers.get(e)?.get(s) ?? this.builtinModels.get(s);
  }
  getAll() {
    const e = this.scopedLayer();
    if (!e) return Array.from(this.models.values());
    const s = new Map(this.builtinModels);
    for (const [i, r] of e) s.set(i, r);
    return Array.from(s.values());
  }
  has(e) {
    return this.get(e) !== void 0;
  }
  /** The types a user should be offered: `getAll()` minus `listed: false` types and types still waiting on `hiddenUntilType`. */
  getListed() {
    return this.getAll().filter((e) => e.listed !== !1 && (!e.hiddenUntilType || this.has(e.hiddenUntilType)));
  }
  isBuiltin(e) {
    return this.builtinTypes.has(e);
  }
  /**
   * The original built-in model for a type, if any — the seed that a workspace
   * or synced patch layers onto. Unaffected by workspace overrides currently in
   * the `models` map, so patch resolution never double-applies.
   */
  getBuiltinModel(e) {
    return this.builtinModels.get(e);
  }
  validate(e, s) {
    const i = this.get(e);
    if (!i)
      return {
        valid: !1,
        errors: [{ field: "type", message: `Unknown tracker type: ${e}` }]
      };
    const r = [], o = [];
    for (const n of i.fields) {
      const a = s[n.name];
      if (n.required && (a == null || a === "")) {
        r.push({
          field: n.name,
          message: `Field '${n.name}' is required`
        });
        continue;
      }
      if (a != null) {
        switch (n.type) {
          case "number":
            typeof a != "number" ? r.push({
              field: n.name,
              message: `Field '${n.name}' must be a number`
            }) : (n.min !== void 0 && a < n.min && r.push({
              field: n.name,
              message: `Field '${n.name}' must be >= ${n.min}`
            }), n.max !== void 0 && a > n.max && r.push({
              field: n.name,
              message: `Field '${n.name}' must be <= ${n.max}`
            }));
            break;
          case "select":
            n.options && !n.options.some((c) => c.value === a) && o.push({
              field: n.name,
              message: `Field '${n.name}' has an unrecognized option: ${a}`
            });
            break;
          case "array":
            Array.isArray(a) || r.push({
              field: n.name,
              message: `Field '${n.name}' must be an array`
            });
            break;
          case "boolean":
            typeof a != "boolean" && r.push({
              field: n.name,
              message: `Field '${n.name}' must be a boolean`
            });
            break;
          case "url": {
            const c = typeof a == "string" ? a : a && typeof a == "object" && typeof a.url == "string" ? a.url : void 0;
            if (!c) {
              r.push({
                field: n.name,
                message: `Field '${n.name}' must be a URL string or { url, label }`
              });
              break;
            }
            try {
              new URL(c);
            } catch {
              r.push({
                field: n.name,
                message: `Field '${n.name}' is not a valid URL: ${c}`
              });
            }
            break;
          }
          case "citation": {
            if (!Array.isArray(a)) {
              r.push({
                field: n.name,
                message: `Field '${n.name}' must be an array of citation references`,
                code: "CITATION_FIELD_NOT_AN_ARRAY"
              });
              break;
            }
            a.forEach((c, l) => {
              const d = c?.itemId;
              (!c || typeof c != "object" || typeof d != "string" || d === "") && r.push({
                field: `${n.name}[${l}]`,
                message: `Field '${n.name}[${l}]' must reference a citation item by itemId`,
                code: "CITATION_FIELD_INVALID_ENTRY"
              });
            });
            break;
          }
          case "predicate-ref": {
            if (typeof a != "string" || a === "") {
              r.push({
                field: n.name,
                message: `Field '${n.name}' must be a predicate id`,
                code: "PREDICATE_REF_NOT_A_STRING"
              });
              break;
            }
            if (this.predicates.size === 0) break;
            this.predicates.has(a) || r.push({
              field: n.name,
              message: `Field '${n.name}': unknown predicate '${a}'`,
              code: "PREDICATE_UNKNOWN"
            });
            break;
          }
          case "label-ref": {
            const c = qe(this.getLabelRegistry(), a);
            for (const l of c.errors) r.push({ field: n.name, message: `Field '${n.name}': ${l.message}`, code: l.code });
            for (const l of c.warnings) o.push({ field: n.name, message: `Field '${n.name}': ${l.message}`, code: l.code });
            break;
          }
        }
        if (n.objectShape === "citation-locator") {
          const l = n.type === "array" || n.multiValue === !0 ? de(a) : Q(a);
          for (const d of l.issues)
            r.push({
              field: d.path ? `${n.name}${d.path.startsWith("[") ? "" : "."}${d.path}` : n.name,
              message: `Field '${n.name}': ${d.message}`,
              code: d.code
            });
        }
        n.predicate && this.validatePredicateField(i, n, r);
      }
    }
    return B(i) && je(this.getLabelRegistry(), i, s, o), {
      valid: r.length === 0,
      errors: r,
      ...o.length > 0 ? { warnings: o } : {}
    };
  }
  /**
   * Validate one statement-bearing field against the project's predicate
   * registry (contract 4.1).
   *
   * Two checks, in the order they answer "whose fault is this":
   *
   *  1. The predicate exists. If it does not, nothing below is knowable.
   *  2. The registry still agrees with the field DECLARATION -- value shape and
   *     subject kind. These are schema properties, not data properties, so they
   *     are reported ONCE for the field rather than per entry, and they are
   *     checked here as well as at declaration time because the registry can
   *     move under a field that was valid when it was written. That is exactly
   *     the destructive case `trackerPredicateRegistryChangeClassifier` exists
   *     to gate, and this is what the gate protects.
   */
  validatePredicateField(e, s, i) {
    const r = s.predicate, o = this.getPredicate(r);
    if (!o) {
      i.push({
        field: s.name,
        message: `Field '${s.name}' declares predicate '${r}', which this project's registry does not define`,
        code: "PREDICATE_UNKNOWN"
      });
      return;
    }
    if (!G(o.valueShape, s.type)) {
      i.push({
        field: s.name,
        message: `Field '${s.name}' is a '${s.type}' field and cannot carry predicate '${r}' (value shape '${o.valueShape}')`,
        code: "PREDICATE_VALUE_SHAPE_MISMATCH"
      });
      return;
    }
    H(o.subjectKinds, e.type, this.baseOf) || i.push({
      field: s.name,
      message: `Predicate '${r}' accepts subjects of ${o.subjectKinds.join(", ")}, not '${e.type}'`,
      code: "PREDICATE_SUBJECT_KIND_NOT_ALLOWED"
    });
  }
}
function je(t, e, s, i) {
  if (t.properties.length === 0) return;
  const r = s.customFields && typeof s.customFields == "object" ? s.customFields : {};
  for (const o of t.properties) {
    const n = e.fields.some((c) => c.name === o.id) ? void 0 : s[o.id], a = r[o.id] ?? n;
    if (a != null)
      for (const c of ke(o, a))
        i.push({
          field: c.path ? `${o.id}.${c.path}` : o.id,
          message: c.message,
          code: c.code
        });
  }
}
function B(t) {
  return t.fields.some((e) => e.type === "label-ref");
}
const K = P(), Me = /* @__PURE__ */ new Map(), Ue = /* @__PURE__ */ new Map(), Ve = new we(), Y = {
  name: "tags",
  type: "array",
  itemType: "string",
  displayInline: !1
};
function D(t) {
  if (t.supportsTags === !1) return t;
  if (t.roles?.tags != null)
    return t.roles.tags !== "tags" || t.fields.some((r) => r.name === "tags") ? t : { ...t, fields: [...t.fields, Y] };
  const s = t.fields.some((r) => r.name === "tags") ? t.fields : [...t.fields, Y], i = {
    ...t.roles ?? {},
    tags: "tags"
  };
  return { ...t, fields: s, roles: i };
}
function We(t, e) {
  return t.roles?.[e];
}
function Xe(t, e, s) {
  const i = t.get(e);
  if (!i) return;
  const r = We(i, s);
  if (r)
    return i.fields.find((o) => o.name === r);
}
function et(t) {
  const e = /* @__PURE__ */ new Set(), s = [];
  for (const i of t) {
    const r = Ve.get(i);
    if (r)
      for (const o of r.fields)
        e.has(o.name) || (e.add(o.name), s.push(o));
  }
  return s;
}
export {
  D as A,
  Xe as B,
  C,
  De as D,
  G as E,
  Je as F,
  et as G,
  de as H,
  ke as I,
  Te as J,
  qe as K,
  ze as L,
  Ie as M,
  Le as N,
  Qe as O,
  me as P,
  ne as S,
  Be as T,
  Ce as a,
  Pe as b,
  We as c,
  Ye as d,
  ve as e,
  H as f,
  Ve as g,
  He as h,
  Fe as i,
  xe as j,
  Oe as k,
  Ze as l,
  P as m,
  O as n,
  z as o,
  Re as p,
  F as q,
  v as r,
  U as s,
  Se as t,
  M as u,
  Q as v,
  he as w,
  we as x,
  Ge as y,
  Ke as z
};
//# sourceMappingURL=TrackerDataModel-D7fU-Wum.js.map
